import Vue from 'vue';
import App from './App.vue';
import NowUiKit from './plugins/now-ui-kit';
import data from './data/data.json';

Vue.config.productionTip = false;

Vue.use(NowUiKit);


new Vue({
    render: h => h(App, { props: { data } })
}).$mount('#app');
